export const apiPath = '/v1/cards';
const actionType = 'TYPE_OF_ACTION';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
